export const videoPageDict = {
  ru: {
    video: 'Видео',
    videoReviews:
      'Подробные видеоруководства по программам: особенности и нюансы, а также примеры из практики.',
    watchNow: 'Смотреть сейчас',
    allVideo: 'Все видео',
  },
};
